const mapCard = (json) => {
    const {
        id,
        profile_name,
        profile_headers,
        created_at,
        updated_at,
    } = json;

    return [
        [
            {
                labels: ["ID"],
                value: id,
                type: "number",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Name"],
                value: profile_name,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Headers"],
                value: profile_headers || "-",
                type: "string",
                align: "align-left",
                basis: "40%",
            },
        ],
        [
            {
                labels: ["Created At"],
                value: created_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Updated At"],
                value: updated_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    entity: id,
                    customComponent: "Goto",
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["ID"],
        columnName: "id",
        type: "number",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Profile Name"],
        columnName: "profile_name",
        type: "string",
        align: "left",
        editable: true,
        sortable: true,
    },
    {
        label: ["Profile Headers"],
        columnName: "profile_headers",
        type: "string",
        align: "left",
        editable: false,
        sortable: false,
        basis: "25%",
    },
    {
        label: ["Created At"],
        columnName: "created_at",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Updated At"],
        columnName: "updated_at",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Actions"],
        type: "customComponent",
        align: "center"
    },
];

const importProfilesMapper = {
    map: mapper,
    header,
};

export default importProfilesMapper;

